var _defineProperty = require("/Users/challen/code/mace/example/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/Users/challen/code/mace/example/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var React__default = _interopDefault(React);

var PropTypes = _interopDefault(require('prop-types'));

var GoogleLoginContext = React__default.createContext({
  available: false,
  auth: null,
  user: null,
  ready: false,
  err: undefined,
  isSignedIn: false,
  loggingIn: false,
  setLoggingIn: function setLoggingIn() {
    throw Error("GoogleLoginContext not defined");
  }
});

var GoogleLoginProvider = function GoogleLoginProvider(_ref) {
  var clientConfig = _ref.clientConfig,
      libraryURI = _ref.libraryURI,
      children = _ref.children;

  var _React$useState = React.useState({
    auth: null,
    ready: false,
    err: undefined
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      auth = _React$useState2[0],
      setAuth = _React$useState2[1];

  var _React$useState3 = React.useState({
    user: null,
    isSignedIn: undefined
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      user = _React$useState4[0],
      setUser = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      loggingIn = _React$useState6[0],
      setLoggingIn = _React$useState6[1];

  var initialize = React.useCallback(function () {
    window.gapi.load("auth2", function () {
      window.gapi.auth2.init(clientConfig).then(function (newAuth) {
        setAuth({
          auth: newAuth,
          ready: true,
          err: undefined
        });
        var initialUser = newAuth.currentUser.get();
        setUser({
          user: initialUser,
          isSignedIn: initialUser.isSignedIn()
        });
        newAuth.currentUser.listen(function (newUser) {
          setUser({
            user: newUser,
            isSignedIn: newUser.isSignedIn()
          });
          newUser.isSignedIn();
        });
      }, function (err) {
        setAuth({
          auth: null,
          ready: false,
          err: err
        });
        throw err;
      });
    });
  }, [clientConfig]);
  React.useEffect(function () {
    // Allow users to load the Google API separately if they want. Can help with preloading.
    if (window.gapi) {
      initialize();
      return;
    }

    var existingScript = document.querySelector("script[src=\"".concat(libraryURI, "\"]"));

    if (existingScript) {
      existingScript.onload = initialize;
      return;
    }

    var script = Object.assign(document.createElement("script"), {
      src: libraryURI,
      async: true,
      defer: true
    });
    script.onload = initialize;
    document.head.appendChild(script);
    return function () {
      {
        document.head.removeChild(script);
      }
    };
  }, [libraryURI, initialize]);
  return React__default.createElement(GoogleLoginContext.Provider, {
    value: _objectSpread(_objectSpread(_objectSpread({
      available: true
    }, auth), user), {}, {
      loggingIn: loggingIn,
      setLoggingIn: setLoggingIn
    })
  }, children);
};

GoogleLoginProvider.propTypes = {
  clientConfig: PropTypes.exact({
    client_id: PropTypes.string.isRequired,
    cookie_policy: PropTypes.string,
    scope: PropTypes.string,
    fetch_basic_profile: PropTypes.bool,
    hosted_domain: PropTypes.string,
    openid_realm: PropTypes.string,
    ux_mode: PropTypes.string,
    redirect_uri: PropTypes.string
  }).isRequired,
  libraryURI: PropTypes.string,
  children: PropTypes.node.isRequired
};
GoogleLoginProvider.defaultProps = {
  libraryURI: "https://apis.google.com/js/platform.js"
};

var useGoogleLogin = function useGoogleLogin() {
  return React.useContext(GoogleLoginContext);
};

var WithGoogleLogin = function WithGoogleLogin(_ref2) {
  var children = _ref2.children;
  return children(useGoogleLogin());
};

WithGoogleLogin.propTypes = {
  children: PropTypes.func.isRequired
};

var useGoogleUser = function useGoogleUser() {
  var _React$useContext = React.useContext(GoogleLoginContext),
      user = _React$useContext.user,
      isSignedIn = _React$useContext.isSignedIn;

  return {
    user: user,
    isSignedIn: isSignedIn
  };
};

var WithGoogleUser = function WithGoogleUser(_ref3) {
  var children = _ref3.children;
  return children(useGoogleUser());
};

WithGoogleUser.propTypes = {
  children: PropTypes.func.isRequired
};

var getProfile = function getProfile(user) {
  var profile = user.getBasicProfile();
  return {
    ID: profile.getId(),
    name: profile.getName(),
    givenName: profile.getGivenName(),
    familyName: profile.getFamilyName(),
    imageUrl: profile.getImageUrl(),
    email: profile.getEmail()
  };
};

var getTokens = function getTokens(user) {
  var authResponse = user.getAuthResponse();
  return {
    id_token: authResponse.id_token,
    access_token: authResponse.access_token
  };
};

var useGoogleTokens = function useGoogleTokens() {
  var _React$useContext2 = React.useContext(GoogleLoginContext),
      user = _React$useContext2.user,
      isSignedIn = _React$useContext2.isSignedIn;

  if (!user || !isSignedIn) {
    return {
      idToken: undefined,
      accessToken: undefined
    };
  }

  var _getTokens = getTokens(user),
      idToken = _getTokens.id_token,
      accessToken = _getTokens.access_token;

  return {
    idToken: idToken,
    accessToken: accessToken
  };
};

var WithGoogleTokens = function WithGoogleTokens(_ref4) {
  var children = _ref4.children;
  return children(useGoogleTokens());
};

WithGoogleTokens.propTypes = {
  children: PropTypes.func.isRequired
};

var useGoogleEmail = function useGoogleEmail() {
  var _React$useContext3 = React.useContext(GoogleLoginContext),
      user = _React$useContext3.user,
      isSignedIn = _React$useContext3.isSignedIn;

  if (!user || !isSignedIn) {
    return undefined;
  }

  return user === null || user === void 0 ? void 0 : user.getBasicProfile().getEmail();
};

var WithGoogleEmail = function WithGoogleEmail(_ref5) {
  var children = _ref5.children;
  return children(useGoogleEmail());
};

WithGoogleEmail.propTypes = {
  children: PropTypes.func.isRequired
};

var useBasicGoogleProfile = function useBasicGoogleProfile() {
  var _React$useContext4 = React.useContext(GoogleLoginContext),
      user = _React$useContext4.user,
      isSignedIn = _React$useContext4.isSignedIn;

  if (!user || !isSignedIn) {
    return {};
  }

  var profile = user === null || user === void 0 ? void 0 : user.getBasicProfile();
  return profile ? {
    email: profile.getEmail(),
    name: profile.getName()
  } : {};
};

var WithBasicGoogleProfile = function WithBasicGoogleProfile(_ref6) {
  var children = _ref6.children;

  var _useBasicGoogleProfil = useBasicGoogleProfile(),
      email = _useBasicGoogleProfil.email,
      name = _useBasicGoogleProfil.name;

  return children(email, name);
};

WithBasicGoogleProfile.propTypes = {
  children: PropTypes.func.isRequired
};
exports.GoogleLoginProvider = GoogleLoginProvider;
exports.WithBasicGoogleProfile = WithBasicGoogleProfile;
exports.WithGoogleEmail = WithGoogleEmail;
exports.WithGoogleLogin = WithGoogleLogin;
exports.WithGoogleTokens = WithGoogleTokens;
exports.WithGoogleUser = WithGoogleUser;
exports.getProfile = getProfile;
exports.getTokens = getTokens;
exports.useBasicGoogleProfile = useBasicGoogleProfile;
exports.useGoogleEmail = useGoogleEmail;
exports.useGoogleLogin = useGoogleLogin;
exports.useGoogleTokens = useGoogleTokens;
exports.useGoogleUser = useGoogleUser;